import { Control, Controller, FieldPath, FieldValues } from 'react-hook-form';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';

interface BooleanGroupProps<T extends FieldValues> {
  control: Control<T>;
  name: FieldPath<T>;
  label: string;
  error?: string;
}

export function BooleanGroup<T extends FieldValues>({
  control,
  name,
  label,
  error,
}: BooleanGroupProps<T>) {
  return (
    <div className="space-y-4">
      <Label className="text-base font-semibold text-brand-dark leading-relaxed">{label}</Label>
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <RadioGroup
            value={field.value?.toString() || ''}
            onValueChange={(value) => field.onChange(value === 'true')}
            className="flex space-x-12"
          >
            <div className="flex items-center space-x-3">
              <RadioGroupItem value="true" id={`${name}-yes`} className="border-slate-300 focus:ring-brand-orange/20" />
              <Label htmlFor={`${name}-yes`} className="text-base font-medium cursor-pointer text-brand-dark">Yes</Label>
            </div>
            <div className="flex items-center space-x-3">
              <RadioGroupItem value="false" id={`${name}-no`} className="border-slate-300 focus:ring-brand-orange/20" />
              <Label htmlFor={`${name}-no`} className="text-base font-medium cursor-pointer text-brand-dark">No</Label>
            </div>
          </RadioGroup>
        )}
      />
      {error && <p className="text-sm text-red-600 mt-2 font-medium">{error}</p>}
    </div>
  );
}